import "./ServicesBoard.scss";
import { ServicesIcon, BusinessIcon, AssetsIcon, AddIcon, SearchIcon, ExternalLinkIcon } from "../../../../../shared/cockpit/components/icons/Icon";

interface ServiceEntry {
  id: string;
  type: string;
  description: string;
  project: string;
  object: string;
  status: "PLANNING" | "REQUESTED" | "IN_PROGRESS" | "COMPLETED";
  partner: string;
}

const servicesData: ServiceEntry[] = [
  {
    id: "S1",
    type: "EV_CHARGING",
    description: "10x AC 22kW, 2x DC 150kW",
    project: "Retrofit Ladeinfrastruktur & PV",
    object: "FitX Berlin-Alexanderplatz",
    status: "PLANNING",
    partner: "Nicht zugewiesen",
  },
  {
    id: "S2",
    type: "PV",
    description: "Dach-PV 150 kWp",
    project: "Retrofit Ladeinfrastruktur & PV",
    object: "FitX Berlin-Alexanderplatz",
    status: "REQUESTED",
    partner: "Nicht zugewiesen",
  },
  {
    id: "S3",
    type: "EV_CHARGING",
    description: "2x Hypercharger 300kW",
    project: "Schnelllader-Installation",
    object: "Casino Royal Dortmund",
    status: "IN_PROGRESS",
    partner: "Elektro Schulz GmbH",
  },
  {
    id: "S4",
    type: "TENANT_ELEC",
    description: "Mieterstromkonzept für 45 Parteien",
    project: "Mieterstrom & Wärmepumpe",
    object: "Hafenquartier Hamburg",
    status: "COMPLETED",
    partner: "Nicht zugewiesen",
  },
];

function ServicesBoard() {
  return (
    <div className="services-board-view">
      <header className="services-board-view__header">
        <div className="services-board-view__header__content">
          <div className="services-board-view__header__title--container">
            <div className="services-board-view__header__icon-wrapper">
              <ServicesIcon />
            </div>
            <h2 className="services-board-view__header__title">
              Leistungen & Board
            </h2>
          </div>
          <p className="services-board-view__header__subtitle">
            Operative Steuerung aller laufenden Gewerke, Leistungen und Partner.
          </p>
        </div>
        <button className="services-board-view__header__add-btn">
          <AddIcon /> Neue Leistung
        </button>
      </header>

      <div className="services-board-view__content">
        <div className="services-board-view__search-bar">
          <SearchIcon className="services-board-view__search-icon" />
          <input
            type="text"
            placeholder="Leistung, Projekt oder Partner suchen..."
          />
        </div>

        <div className="services-table">
          <div className="services-table__header">
            <div className="services-table__col">LEISTUNG (GEWERK)</div>
            <div className="services-table__col">PROJEKT & OBJEKT</div>
            <div className="services-table__col">STATUS</div>
            <div className="services-table__col">PARTNER</div>
            <div className="services-table__col text-right">AKTION</div>
          </div>

          <div className="services-table__body">
            {servicesData.map((service) => (
              <div key={service.id} className="services-table__row">
                <div className="services-table__col">
                  <div className="service-info">
                    <span className="service-info__type">{service.type}</span>
                    <span className="service-info__desc">
                      {service.description}
                    </span>
                    <span className="service-info__id">ID: {service.id}</span>
                  </div>
                </div>

                <div className="services-table__col">
                  <div className="project-object-info">
                    <div className="project-line">
                      <BusinessIcon className="icon-project" />
                      <span>{service.project}</span>
                    </div>
                    <div className="object-line">
                      <AssetsIcon className="icon-object" />
                      <span>{service.object}</span>
                    </div>
                  </div>
                </div>

                <div className="services-table__col">
                  <span
                    className={`status-badge status-badge--${service.status.toLowerCase()}`}
                  >
                    {service.status}
                  </span>
                </div>

                <div className="services-table__col">
                  <span className="partner-name">{service.partner}</span>
                </div>

                <div className="services-table__col text-right">
                  <button className="action-btn">
                    <ExternalLinkIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesBoard;
